import { Link } from 'react-router-dom'
import { ROUTES } from '@/constants/routes'
import { isOktaConfigured } from '@/config/okta'

/**
 * Sign up is admin-only: users are created by admins (e.g. User Management).
 * Auth will be hosted on Okta. This page informs visitors and links to Sign in.
 */
export default function SignUp() {
  const oktaSignIn = isOktaConfigured()

  return (
    <div className="min-h-screen flex">
      {/* Left column - Message */}
      <div className="w-full lg:w-[55%] xl:w-[50%] flex flex-col bg-white px-6 sm:px-10 py-8 lg:py-12 overflow-y-auto">
        <div className="max-w-[420px] mx-auto w-full">
          {/* Logo - centred on left side */}
          <div className="flex justify-center mb-10">
            <Link to={ROUTES.LOGIN}>
              <img
                src="/images/logo.png"
                alt="KAY CURZI GROUP"
                className="object-contain"
                style={{ width: 210, height: 101 }}
              />
            </Link>
          </div>

          <h2
            className="font-lexend font-bold text-2xl mb-1"
            style={{ color: '#212126' }}
          >
            Sign up to your account
          </h2>
          <p className="text-black-sub text-sm mb-6">
            Already registered?{' '}
            <Link
              to={ROUTES.LOGIN}
              className="font-medium hover:underline"
              style={{ color: '#2C71F6' }}
            >
              Sign in
            </Link>
          </p>

          <div className="rounded-lg border border-black-border bg-primary-50/50 p-5 mb-6">
            <p
              className="font-sans text-sm leading-relaxed"
              style={{ color: '#212126' }}
            >
              {oktaSignIn
                ? 'Use your organization account to sign in. New users are created automatically on first login, or contact your administrator for access.'
                : 'Account creation is by invitation only. Contact your administrator to get an account.'}
            </p>
          </div>

          <Link
            to={ROUTES.LOGIN}
            className="block w-full py-3.5 rounded-lg font-lexend font-semibold text-sm text-white text-center transition-colors hover:opacity-95"
            style={{ backgroundColor: '#212126' }}
          >
            {oktaSignIn ? 'Sign in with Okta' : 'Sign in'}
          </Link>
        </div>
      </div>

      {/* Right column - Hero image (cargo ship) */}
      <div
        className="hidden lg:block lg:flex-1 bg-cover bg-center bg-no-repeat min-h-screen"
        style={{
          backgroundImage: 'url(/images/signup-hero.jpeg)',
          backgroundColor: '#0f172a',
        }}
        role="img"
        aria-label="Cargo ship at port at night"
      />
    </div>
  )
}
